import React from 'react';
import { MinimumWagesSection } from '../../data/sections/MinimumWagesSection';

const MinimumWage = ({ country }) => {
  const fetchMinimumWage = country
    ? MinimumWagesSection.countries.find(
        (c) =>
          c.country.replace(/\s+/g, '-').toLowerCase() ===
          country.replace(/\s+/g, '-').toLowerCase()
      )
    : null;

  if (!fetchMinimumWage) {
    return <p>Country not found or data not available.</p>;
  }

  
  return (
    <div className="minimum-wage-container">
      <h3 >Minimum Wage</h3>
      <p >{fetchMinimumWage.details.description}</p>

      {fetchMinimumWage.details.update && (
        <div className="minimum-wagdetail">
          <p className="new-law">
            <strong>New Law:</strong> {fetchMinimumWage.details.update.new_law}
          </p>
          <p className="new-wage">
            <strong>New Wage:</strong> {fetchMinimumWage.details.update.new_wage}
          </p>
        </div>
      )}
    </div>
  );
};

export default MinimumWage;
